/* Produktseite: Mengenstaffel, Versandkosten-Vorschau und
   rechtlicher Hinweis.

   Die Staffel-Karten setzen die Menge im Mengenfeld. Die
   Versandzeile rechnet aus Menge und Stueckpreis den Bestellwert
   und zeigt 1,99 EUR oder 0,00 EUR in Gold.

   Staffel-Karten und der Kennzeichen-Rechtshinweis erscheinen NUR
   auf den Produktseiten, deren Handle in TIER_SETS steht. Die
   Staffelpreise sind je Produkt fest hinterlegt, weil sie vom
   Stueckpreis abhaengen. Auf allen anderen Produkten waeren sie
   falsch und verwirrend. Die Versandzeile bleibt ueberall, rechnet
   dort aber ohne Mengenrabatt.

   Soll die Staffel fuer ein weiteres Produkt gelten: Handle in
   TIER_SETS ergaenzen UND in snippets/stylesheets.liquid.

   Alles als eigene Elemente, damit an Horizons Bausteinen nichts
   veraendert werden muss. Defensiv: schlaegt etwas fehl, bleibt
   die Seite unveraendert. */
(function () {
  var FREE_FROM_CENTS = 3500;      // Gratis-Versand ab 35,00 EUR (Shopify-Versandregel)
  var SHIPPING_CENTS = 199;        // sonst 1,99 EUR
  var DISCOUNT_FROM = 3;           // Mengenrabatt ab 3 Stueck
  var DISCOUNT_PER_ITEM = 199;     // 1,99 EUR pro Stueck, passend zum
                                   // Shopify-Rabatt "Mengenrabatt ab 3 Stueck"

  /* Staffelpreise je Produkt-Handle. Muss zum automatischen
     Shopify-Rabatt passen (1,99 EUR pro Stueck ab 3 Stueck). */
  var TIER_SETS = {
    /* 11,99 EUR pro Stueck -> ab 3 Stueck 10,00 EUR */
    '3d-gedruckter-kennzeichenhalter': [
      { top: '1 Stück', was: '', now: 'Einzeln kaufen', qty: 1, gold: false },
      { top: '3er-Pack', was: '35,97 €', now: 'nur 30 €', qty: 3, gold: false },
      { top: '4er-Pack', was: '47,96 €', now: '40 € + Gratis Versand', qty: 4, gold: true }
    ],
    /* V2: 14,99 EUR pro Stueck -> ab 3 Stueck 13,00 EUR */
    'max-g3-v2-quick-release-kennzeichenhalter-kopie': [
      { top: '1 Stück', was: '', now: 'Einzeln kaufen', qty: 1, gold: false },
      { top: '3er-Pack', was: '44,97 €', now: 'nur 39 € + Gratis Versand', qty: 3, gold: false },
      { top: '4er-Pack', was: '59,96 €', now: '52 € + Gratis Versand', qty: 4, gold: true }
    ]
  };

  var LEGAL =
    'Hinweis: Bitte prüfe vor der Montage die Vorschriften an deinem Wohnort. ' +
    'Kennzeichen müssen jederzeit vollständig lesbar, fest angebracht und ' +
    'vorschriftsmäßig beleuchtet sein. Für die zulässige Verwendung ist der ' +
    'Fahrzeughalter verantwortlich.';

  /* Handle der aktuellen Produktseite. Bevorzugt das Liquid-Flag
     aus snippets/stylesheets.liquid, faellt sonst auf die URL zurueck. */
  function currentHandle() {
    try {
      if (typeof window.JT_PRODUCT_HANDLE === 'string' && window.JT_PRODUCT_HANDLE) {
        return window.JT_PRODUCT_HANDLE;
      }
      var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : '';
    } catch (e) {
      return '';
    }
  }

  function tiersFor(handle) {
    return Object.prototype.hasOwnProperty.call(TIER_SETS, handle) ? TIER_SETS[handle] : null;
  }

  /* true nur auf einer Produktseite mit Mengenstaffel. */
  function tiersEnabled() {
    try {
      if (window.JT_SHOW_TIERS === false) return false;
      return tiersFor(currentHandle()) !== null;
    } catch (e) {
      return false;
    }
  }

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function quantityInput() {
    return (
      document.querySelector('product-form-component input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]')
    );
  }

  function unitPriceCents() {
    try {
      var el = document.querySelector('product-price');
      if (!el) return null;
      var m = (el.textContent || '').replace(/\s/g, '').match(/([0-9]+(?:[.,][0-9]{2})?)/);
      if (!m) return null;
      var v = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
      return isNaN(v) ? null : Math.round(v * 100);
    } catch (e) {
      return null;
    }
  }

  function updateShipping() {
    try {
      var row = document.querySelector('.jt-shipping');
      if (!row) return;

      var input = quantityInput();
      var qty = input ? parseInt(input.value, 10) : 1;
      if (!qty || qty < 1) qty = 1;

      var unit = unitPriceCents();
      if (unit === null) return;

      var subtotal = unit * qty;
      if (tiersEnabled() && qty >= DISCOUNT_FROM) {
        subtotal = Math.max(0, unit - DISCOUNT_PER_ITEM) * qty;
      }

      var free = subtotal >= FREE_FROM_CENTS;
      var value = row.querySelector('.jt-shipping__value');
      if (!value) return;

      value.textContent = free ? '0,00 €' : euro(SHIPPING_CENTS);
      if (free) {
        row.classList.add('jt-shipping--free');
      } else {
        row.classList.remove('jt-shipping--free');
      }
    } catch (e) {
      /* still */
    }
  }

  function setQuantity(qty) {
    try {
      var input = quantityInput();
      if (!input) return;
      input.value = String(qty);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateShipping();
    } catch (e) {
      /* still */
    }
  }

  function markActive(wrap, qty) {
    var cards = wrap.querySelectorAll('.jt-tier');
    for (var i = 0; i < cards.length; i++) {
      cards[i].setAttribute(
        'aria-pressed',
        String(cards[i].dataset.qty) === String(qty) ? 'true' : 'false'
      );
    }
  }

  function buildTiers(tiers) {
    var wrap = document.createElement('div');
    wrap.className = 'jt-tiers';

    for (var i = 0; i < tiers.length; i++) {
      (function (t) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'jt-tier' + (t.gold ? ' jt-tier--gold' : '');
        card.dataset.qty = t.qty;
        card.setAttribute('aria-pressed', 'false');

        var top = document.createElement('strong');
        top.textContent = t.top;
        card.appendChild(top);

        if (t.was || t.now) {
          var bottom = document.createElement('span');
          if (t.was) {
            var was = document.createElement('s');
            was.className = 'jt-tier__was';
            was.textContent = t.was;
            bottom.appendChild(was);
            bottom.appendChild(document.createTextNode(' '));
          }
          if (t.now) {
            bottom.appendChild(document.createTextNode(t.now));
          }
          card.appendChild(bottom);
        }

        card.addEventListener('click', function () {
          setQuantity(t.qty);
          markActive(wrap, t.qty);
        });

        wrap.appendChild(card);
      })(tiers[i]);
    }
    return wrap;
  }

  function buildShipping() {
    var row = document.createElement('div');
    row.className = 'jt-shipping';

    var label = document.createElement('span');
    label.className = 'jt-shipping__label';
    label.textContent = 'Voraussichtlicher Versand';

    var value = document.createElement('strong');
    value.className = 'jt-shipping__value';
    value.textContent = euro(SHIPPING_CENTS);

    row.appendChild(label);
    row.appendChild(value);
    return row;
  }

  function buildLegal() {
    var p = document.createElement('p');
    p.className = 'jt-legal-note';
    p.textContent = LEGAL;
    return p;
  }

  /* Entfernt Staffel und Rechtshinweis wieder, falls sie auf einer
     Seite ohne Mengenstaffel stehengeblieben sind. */
  function removeTierElements(parent) {
    try {
      var stale = parent.querySelectorAll('.jt-tiers, .jt-legal-note');
      for (var i = 0; i < stale.length; i++) {
        if (stale[i].parentNode) stale[i].parentNode.removeChild(stale[i]);
      }
    } catch (e) {
      /* still */
    }
  }

  function place() {
    try {
      var target = document.querySelector('.product-form-buttons');
      if (!target || !target.parentNode) return;
      var parent = target.parentNode;
      var tiers = tiersEnabled() ? tiersFor(currentHandle()) : null;

      if (!tiers) {
        removeTierElements(parent);
      } else {
        if (!parent.querySelector('.jt-tiers')) {
          var tiersEl = buildTiers(tiers);
          parent.insertBefore(tiersEl, target);
          var input = quantityInput();
          var currentQty = input ? parseInt(input.value, 10) : 1;
          if (!currentQty || currentQty < 1) currentQty = 1;
          markActive(tiersEl, currentQty);
        }
        if (!parent.querySelector('.jt-legal-note')) {
          parent.insertBefore(buildLegal(), target.nextSibling);
        }
      }

      if (!parent.querySelector('.jt-shipping')) {
        parent.insertBefore(buildShipping(), target);
      }
      updateShipping();
    } catch (e) {
      /* still */
    }
  }

  function start() {
    place();
    try {
      var root = document.querySelector('product-form-component') || document.body;
      new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          place();
          updateShipping();
        });
      }).observe(root, { subtree: true, childList: true, characterData: true });

      document.addEventListener('input', function (e) {
        if (e.target && e.target.name === 'quantity') updateShipping();
      });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'quantity') updateShipping();
      });
      document.addEventListener('click', function () {
        window.setTimeout(updateShipping, 80);
      });
    } catch (e) {
      /* still */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
